import {createUniversalFetch, navigateTo, useAuth, useLogger, type Language} from '#imports';

const universalFetch = createUniversalFetch({baseURL: '/navbar'});

export function useLocalizationSelection() {
    const logger = useLogger();
    const {loggedIn} = useAuth();

    async function changeLanguageAndRedirect(selectedLanguage: Language) {
        if (selectedLanguage.host) {
            if (loggedIn) {
                await _changeLanguageAndRedirectForLoggedInUser(selectedLanguage.host);
            } else {
                await _changeLanguageAndRedirectForUnloggedUser(selectedLanguage.host);
            }
        }
    }

    // @XAuthTours(step = tour_send_redirect, includeCode = true)
    async function _changeLanguageAndRedirectForLoggedInUser(newHost: string): Promise<void> {
        // lib-front-shared-domains/nuxt-navbar-module/src/runtime/logged/features/language-selector/language-selector.store.ts
        try {
            const redirectUrl = new URL(window.location.toString());
            redirectUrl.searchParams.delete('lg');
            redirectUrl.host = newHost;

            const userToken = await universalFetch<string>('/api/user/x-auth-token');
            await universalFetch('/api/user/unsudosu', {method: 'POST'});

            const xAuthUrl = new URL(`${window.location.protocol}//${newHost}/navbar/api/xauth`);
            xAuthUrl.searchParams.append('redirectUrl', redirectUrl.toString());
            xAuthUrl.searchParams.append('x-auth', userToken);

            navigateTo(xAuthUrl.toString(), {external: true});
        } catch (e) {
            logger.error("Can't change language", e);
        }
    }
    function _changeLanguageAndRedirectForUnloggedUser(newHost: string) {
        if (newHost) {
            const url = new URL(window.location.href);
            url.host = newHost;

            navigateTo(url.toString(), {external: true});
        }
    }

    return {
        // functions A-Z
        changeLanguageAndRedirect,
        // refs A-Z
    };
}
